  if (!customElements.get('alb-product-gallery')) {
    customElements.define('alb-product-gallery', class extends HTMLElement {
      connectedCallback(){
        var self = this;
        this.main   = this.querySelector('[data-main]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-main] .alb-mp-slide'));
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
        this.dotsBox = this.querySelector('[data-dots]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.dots = [];
        this.current = 0;
        this.visible = this.slides.map(function(_, i){ return i; });

        this.thumbs.forEach(function(t){
          t.addEventListener('click', function(){ self.show(parseInt(t.getAttribute('data-thumb'),10)); });
        });
        // Pfeile: vor/zurück durch die SICHTBAREN Bilder, mit Umlauf (wie Live-Swiper loop:true)
        if (this.prevBtn) this.prevBtn.addEventListener('click', function(){ self.step(-1); });
        if (this.nextBtn) this.nextBtn.addEventListener('click', function(){ self.step(1); });

        // Mobile-Swipe → aktiven Punkt aktualisieren (Index in der SICHTBAREN Liste)
        if (this.main){
          var ticking = false;
          this.main.addEventListener('scroll', function(){
            if (ticking) return; ticking = true;
            window.requestAnimationFrame(function(){
              var vi = Math.round(self.main.scrollLeft / self.main.clientWidth);
              vi = Math.max(0, Math.min(vi, self.visible.length - 1));
              if (self.visible.length) self.setActive(self.visible[vi]);
              ticking = false;
            });
          }, { passive: true });
        }

        this.refresh();
      }
      // Sichtbarkeit: Varianten-Filter (data-variant-filter) + max. Anzahl (data-thumb-max).
      // Gilt für Thumbnails UND Slides (mobiler Swiper), Punkte werden neu aufgebaut.
      refresh(){
        var self = this;
        var vf  = this.getAttribute('data-variant-filter') === '1';
        var cur = this.getAttribute('data-current-variant') || '';
        var max = parseInt(this.getAttribute('data-thumb-max') || '0', 10);
        var shown = 0;
        this.visible = [];
        this.slides.forEach(function(sl, i){
          var vis = true;
          if (vf){
            var vids = sl.getAttribute('data-vids');
            if (vids && (' ' + vids + ' ').indexOf(' ' + cur + ' ') === -1) vis = false;
          }
          if (vis && max > 0 && shown >= max) vis = false;
          if (vis){ shown++; self.visible.push(i); }
          sl.toggleAttribute('hidden', !vis);
          if (self.thumbs[i]) self.thumbs[i].toggleAttribute('hidden', !vis);
        });
        var few = this.visible.length < 2;
        if (this.prevBtn) this.prevBtn.toggleAttribute('hidden', few);
        if (this.nextBtn) this.nextBtn.toggleAttribute('hidden', few);
        this.buildDots();
        var act = -1;
        this.slides.forEach(function(sl, i){ if (sl.hasAttribute('data-active')) act = i; });
        if (this.visible.length && this.visible.indexOf(act) === -1){ this.show(this.visible[0]); }
        else if (act !== -1){ this.setActive(act); }
      }
      buildDots(){
        var self = this;
        if (!this.dotsBox) return;
        this.dotsBox.innerHTML = ''; this.dots = [];
        if (this.visible.length < 2) return;
        this.visible.forEach(function(idx, vi){
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'alb-mp-dot';
          b.setAttribute('aria-label', 'Bild ' + (vi + 1));
          b.addEventListener('click', function(){ self.scrollTo(idx); });
          self.dotsBox.appendChild(b); self.dots.push(b);
        });
      }
      // Vom Varianten-Picker: neue Variante → neu filtern + zum Variantenbild springen
      setVariant(vid, mediaId){
        this.setAttribute('data-current-variant', vid || '');
        if (this.getAttribute('data-variant-filter') === '1') this.refresh();
        if (mediaId){
          var target = -1;
          this.slides.forEach(function(sl, i){ if (sl.getAttribute('data-media-id') === mediaId) target = i; });
          if (target !== -1 && this.visible.indexOf(target) !== -1) this.scrollTo(target);
        }
      }
      // Pfeil-Navigation: einen Schritt in der sichtbaren Liste, mit Umlauf.
      step(dir){
        if (this.visible.length < 2) return;
        var vi = this.visible.indexOf(this.current);
        if (vi === -1) vi = 0;
        vi = (vi + dir + this.visible.length) % this.visible.length;
        this.scrollTo(this.visible[vi]);
      }
      scrollTo(i){
        if (this.main && this.main.scrollWidth > this.main.clientWidth + 4){
          var vi = this.visible.indexOf(i); if (vi === -1) vi = 0;
          this.main.scrollTo({ left: this.main.clientWidth * vi, behavior: 'smooth' });
          this.show(i);
        } else { this.show(i); }
      }
      setActive(i){
        this.current = i;
        var vi = this.visible.indexOf(i);
        this.dots.forEach(function(d, di){ d.classList.toggle('is-active', di === vi); });
        var act = null;
        this.thumbs.forEach(function(t){
          var on = parseInt(t.getAttribute('data-thumb'),10) === i;
          t.classList.toggle('is-active', on);
          if (on) act = t;
        });
        if (act) this.revealThumb(act);
      }
      // Thumbnail-Leiste mitfuehren: aktives Thumb in der Swipebar zentrieren.
      // Nur wenn die Leiste wirklich ueberlaeuft (Raster-Layout und Mobil = aus).
      // Gemessen wird per Rect-Differenz, weil der Scroll-Container nicht
      // zwingend der offsetParent der Kachel ist.
      revealThumb(el){
        var box = this.querySelector('[data-thumbs]');
        if (!box || el.hasAttribute('hidden')) return;
        var max = box.scrollWidth - box.clientWidth;
        if (max <= 4) return;
        var er = el.getBoundingClientRect(), br = box.getBoundingClientRect();
        if (!br.width) return;
        var left = box.scrollLeft + (er.left - br.left) - (br.width - er.width) / 2;
        left = Math.max(0, Math.min(left, max));
        if (Math.abs(left - box.scrollLeft) < 2) return;
        if (box.scrollTo) box.scrollTo({ left: left, behavior: 'smooth' });
        else box.scrollLeft = left;
      }
      show(i){
        // Desktop: aktives Slide umschalten (Thumbnail-Klick)
        this.slides.forEach(function(sl){ sl.toggleAttribute('data-active', parseInt(sl.getAttribute('data-i'),10) === i); });
        this.setActive(i);
      }
    });
  }

  if (!customElements.get('alb-purchase-selector')) {
    customElements.define('alb-purchase-selector', class extends HTMLElement {
      connectedCallback(){
        var self = this;
        this.planInput  = this.querySelector('[data-selling-plan]');
        this.freq       = this.querySelector('[data-freq]');
        this.planRadios = this.querySelectorAll('[data-plan-radio]');
        this.subPrice   = this.querySelector('[data-sub-price]');
        this.plans      = this.querySelectorAll('[data-choose]');
        var box   = this.closest('.alb-mp-buy');
        this.now  = box.querySelector('[data-price-now]');
        this.discLine = box.querySelector('[data-disc-line]');
        this.onetimeCard = this.querySelector('[data-choose="onetime"] .pnow');

        this.plans.forEach(function(btn){
          btn.addEventListener('click', function(){ self.choose(btn.getAttribute('data-choose')); });
          // Karten sind DIVs (role=radio), damit die Lieferfrequenz-Radios in der Abo-Karte liegen
          // dürfen → Tastatur: Enter/Leertaste auf der Karte selbst wählt sie (nicht auf den Radios).
          btn.addEventListener('keydown', function(e){
            if (e.target !== btn) return;
            if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); self.choose(btn.getAttribute('data-choose')); }
          });
        });
        this.planRadios.forEach(function(r){ r.addEventListener('change', function(){ self.applyPlan(); }); });
        this.choose(this.getAttribute('data-init') || 'onetime');
      }
      choose(type){
        var sub = (type === 'subscription');
        this.plans.forEach(function(btn){
          var on = btn.getAttribute('data-choose') === type;
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-checked', on);
        });
        if (this.freq) this.freq.toggleAttribute('hidden', !sub);
        // Abo hat eigene Preislogik → Rabatt-Vorschau bei Abo ausblenden; die
        // 'alb-discount-preview'-Logik re-rendert bei Einmalkauf via 'alb:purchase-change'.
        if (sub && this.discLine) this.discLine.hidden = true;
        document.dispatchEvent(new CustomEvent('alb:purchase-change', { detail: { type: type } }));
        if (sub){ this.applyPlan(); }
        else {
          if (this.planInput) this.planInput.value = '';
          if (this.now && this.onetimeCard) this.now.textContent = this.onetimeCard.textContent.trim();
        }
      }
      // Variantenwechsel: Abo-Preise der neuen Variante (je Plan) in Radios + Abo-Karte übernehmen
      setVariantPlanPrices(planPrices){
        if (!planPrices) return;
        this.planRadios.forEach(function(r){
          var pr = planPrices[r.value];
          if (pr) r.setAttribute('data-price', pr);
        });
        var subBtn = this.querySelector('[data-choose="subscription"]');
        var mainPlan = subBtn ? subBtn.getAttribute('data-plan') : '';
        var checked = null;
        this.planRadios.forEach(function(r){ if (r.checked) checked = r; });
        var pr = checked ? planPrices[checked.value] : planPrices[mainPlan];
        if (pr && this.subPrice) this.subPrice.textContent = pr;
        if (subBtn && subBtn.classList.contains('is-active')) this.applyPlan();
      }
      applyPlan(){
        var subBtn = this.querySelector('[data-choose="subscription"]');
        var planId, price, checked = null;
        this.planRadios.forEach(function(r){ if (r.checked) checked = r; });
        if (checked){
          planId = checked.value; price = checked.getAttribute('data-price');
        } else {
          planId = subBtn ? (subBtn.getAttribute('data-plan') || '') : '';
          price  = this.subPrice ? this.subPrice.textContent.trim() : '';
        }
        if (this.planInput && planId) this.planInput.value = planId;
        if (this.now && price) this.now.textContent = price;
        if (this.subPrice && price) this.subPrice.textContent = price;
      }
    });
  }

  if (!customElements.get('alb-variant-picker')) {
    customElements.define('alb-variant-picker', class extends HTMLElement {
      connectedCallback(){
        var self = this;
        try {
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          this.prices   = JSON.parse(this.querySelector('[data-variant-prices]').textContent);
        } catch(e){ return; }
        try { this.planPrices = JSON.parse(this.querySelector('[data-variant-plan-prices]').textContent); } catch(e){ this.planPrices = null; }
        var box = this.closest('.alb-mp-buy');
        this.idInput  = box.querySelector('[data-variant-input]');
        this.now      = box.querySelector('[data-price-now]');
        this.cta      = box.querySelector('[data-atc]');
        this.ctaLabel = box.querySelector('[data-cta-label]');
        this.onetimeCard = box.querySelector('[data-choose="onetime"] .pnow');
        this.stockIn  = box.querySelector('[data-stock-in]');
        this.stockOut = box.querySelector('[data-stock-out]');
        this.querySelectorAll('[data-opt-input]').forEach(function(inp){
          inp.addEventListener('change', function(){ self.update(); });
        });
      }
      update(){
        var self = this;
        var chosen = [];
        this.querySelectorAll('.alb-mp-opt').forEach(function(opt, i){
          var checked = opt.querySelector('input[data-opt-input]:checked');
          if (checked) {
            chosen[i] = checked.value;
            var valEl = opt.querySelector('[data-opt-val]');
            if (valEl) valEl.textContent = checked.value;
            opt.querySelectorAll('.alb-mp-sw').forEach(function(sw){
              sw.classList.toggle('is-active', sw.contains(checked));
            });
          }
        });
        var match = this.variants.find(function(v){
          return v.options.every(function(o, idx){ return o === chosen[idx]; });
        });
        if (!match) return;
        this.idInput.value = match.id;
        // Galerie informieren (Varianten-Filter + Sprung zum Variantenbild)
        var grid = this.closest('.alb-mp-grid');
        var gal = grid ? grid.querySelector('alb-product-gallery') : null;
        if (gal && gal.setVariant){
          gal.setVariant(String(match.id), match.featured_media ? String(match.featured_media.id) : '');
        }
        var price = this.prices[match.id];
        // Einmalkauf-Preis + (wenn Einmalkauf aktiv) angezeigter Preis aktualisieren
        if (price && this.onetimeCard) this.onetimeCard.textContent = price;
        var subPlan = this.closest('.alb-mp-buy').querySelector('.alb-mp-plan[data-choose="subscription"]');
        var subActive = subPlan && subPlan.classList.contains('is-active');
        // Streichpreis der Abo-Karte = Einmalpreis der neuen Variante (blieb sonst auf der Startvariante)
        var subWas = subPlan ? subPlan.querySelector('.pprice s:not([data-card-disc-was])') : null;
        if (price && subWas) subWas.textContent = price;
        if (price && this.now && !subActive) this.now.textContent = price;
        // Abo-Karte + Lieferfrequenz-Radios auf die Plan-Preise der neuen Variante setzen
        var sel = this.closest('.alb-mp-buy').querySelector('alb-purchase-selector');
        if (sel && sel.setVariantPlanPrices && this.planPrices) sel.setVariantPlanPrices(this.planPrices[match.id]);
        // Verfügbarkeit
        if (this.cta){
          this.cta.disabled = !match.available;
          if (this.ctaLabel) this.ctaLabel.textContent = match.available
            ? (this.dataset.ctaText || "")
            : (this.dataset.soldOutText || "");
        }
        // Lager-Hinweis (verfügbar / nicht vorrätig) umschalten
        if (this.stockIn)  this.stockIn.hidden  = !match.available;
        if (this.stockOut) this.stockOut.hidden = match.available;
        // Sticky-ATC-Leiste + Rabatt-Vorschau (separate Module) über die aktive Variante informieren
        document.dispatchEvent(new CustomEvent('alb:variant-change', { detail: { id: match.id, available: !!match.available } }));
      }
    });
  }
